export function goBack() {
    if (window.history.length > 1) {
        window.history.back();
    } else {
        this.$inertia.visit("/app/farmer");
    }
}